<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>FITCORPERs Listing</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-toolbar card prominent color="#e0dbe9">
                      <v-toolbar-title>Quick Filter</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>

                        <v-text-field class="px-1"
                          v-model="quick_filter.full_name"
                          label="Full Name"
                        ></v-text-field>
                        <v-text-field class="px-1"
                          v-model="quick_filter.user__username"
                          label="Username"
                        ></v-text-field>
                        <v-select class="px-1"
                          v-model="quick_filter.emp_status__value"
                          :items="emp_status_option"
                          item-text="display"
                          item-value="value"
                        ></v-select>
                        <v-btn small icon color="warning" @click="refreshData">
                          <v-icon size="20">search</v-icon>
                        </v-btn>
                        <v-btn small icon color="secondary" @click="resetData">
                          <v-icon size="20">clear</v-icon>
                        </v-btn>
                         
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear
                            color="blue"
                            indeterminate
                          >
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.rec_id }}</td>
                            <td class="pa-1">{{ props.item.full_name }}</td>
                            <td class="pa-1">
                              {{ props.item.user__username }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.user__email }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.dept_employee__dept__company__name }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.dept_employee__dept__name }}
                            </td>
                            <td class="pa-1">
                              {{ props.item.emp_jg_position__job_grade__desc }}
                            </td>
                            <td class="pa-1">{{ props.item.emp_status__value }}</td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

        </v-container>
      </v-slide-y-transition>
    </v-flex>
  </v-layout>
  
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
// import FilterEditor from "../../components/FilterEditor";

export default {
  name: "FitcorpersListingPage",
  // components: {
  //   FilterEditor: FilterEditor
  // },
  data() {
    return {
      // new_filter: {
      //   condition: "and",
      //   rules: []
      // },
      quick_filter: {
        full_name: "",
        user__username: "",
        emp_status__value: ""
      },
      emp_status_option: [],
      table_setting: {
        loading: false,
        rows_per_page_items: [20, 40, 60, 80, 100, 200, 500, 1000, 2000, 5000],
        headers: [
          {
            text: "ID#",
            value: "rec_id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Full Name",
            class: "pa-1",
            value: "full_name",
            filterable: true,
            data_type: String
          },
          {
            text: "User Name",
            align: "left",
            class: "pa-1",
            value: "user__username",
            filterable: true,
            data_type: String
          },
          {
            text: "Email",
            class: "pa-1",
            value: "user__email",
            filterable: true,
            data_type: String
          },
          {
            text: "Company",
            align: "left",
            class: "pa-1",
            value: "dept_employee__dept__company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Dept Name",
            align: "left",
            class: "pa-1",
            value: "dept_employee__dept__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Job Grade",
            align: "left",
            class: "pa-1",
            value: "emp_jg_position__job_grade__desc",
            filterable: true,
            data_type: String
          },
          {
            text: "Status",
            align: "left",
            class: "pa-1",
            value: "emp_status__value",
            filterable: true,
            data_type: String
          }
        ],
        records: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 20,
          sortBy: "full_name",
          totalItems: 0
        }
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
  },
  async mounted() {
    this.emp_status_option = await common.App.getGeneralOptions(
      "Employee",
      "emp_status",
      ["id", "value"]
    ),
    this.emp_status_option= this.emp_status_option.map(function(el){
      return {
        display:el.value,
        id:el.id,
        value:el.value
      };
    });
    this.emp_status_option.push(
      {
        display:"All Status",
        id:0,
        value:""
      }
    );
    this.quick_filter.emp_status__value = this.emp_status_option[this.emp_status_option.length-1].value;
  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    resetData() {
      window.location.reload();
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";
      cls_qb.Table = "emps_employee";

      cls_qb.Select = [
        "id",
        "full_name",
        "emp_no",
        "ic_no",
        "emp_status_id",
        "emp_status__value",
        "user__username",
        "passport_no",
        "user__email",
        "cost_center_id",
        "cost_center__company__name",
        "cost_center__name",
        "emp_jg_position_id",
        "emp_jg_position__job_grade__desc",
        "created_date",
        "dept_employee__dept__company__name",
        "dept_employee__dept__name",
        "user_id"
      ];


      var rule = new qb.Rule();
      
      var temp = this.quick_filter.full_name.trim();

      if (temp.length>0) {
        rule
          .field("full_name")
          .operator(qb.STR_OPERATOR.I_CONTAINS)
          .value(temp);
        cls_qb.addRule(rule);
      }

      rule = new qb.Rule();
      var temp1 = this.quick_filter.user__username.trim();

      if (temp1.length>0) {
        rule
          .field("user__username")
          .operator(qb.STR_OPERATOR.I_CONTAINS)
          .value(temp1);
        cls_qb.addRule(rule);
      }

      rule = new qb.Rule();
      rule
        .field("emp_status__value")
        .operator(qb.STR_OPERATOR.I_CONTAINS)
        .value(this.quick_filter.emp_status__value);
      cls_qb.addRule(rule);
      
      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        var start = 1;

        for(var i=0,m=result.data.Body.records.length;i<m;i++){
          var el = result.data.Body.records[i];

          el["rec_id"] = el["id"]
          el["id"] = start;
          start++;
        }

        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
      // let cls_qb = new qb.QueryBuilder();

      // cls_qb.Method = "all";

      // cls_qb.Select = [
      //   "id",
      //   "full_name",
      //   "emp_no",
      //   "ic_no",
      //   "emp_status_id",
      //   "emp_status__value",
      //   "user__username",
      //   "passport_no",
      //   "user__email",
      //   "cost_center_id",
      //   "cost_center__company__name",
      //   "cost_center__name",
      //   "emp_jg_position_id",
      //   "created_date",
      //   "dept_employee__dept__company__name",
      //   "dept_employee__dept__name",
      //   "user_id"
      // ];

      // cls_qb.Where = this.new_filter;
      
      // for (var i=0, m=this.quick_filter_status.rules.length; i<m; i++) {
      //   var rule = new qb.Rule();

      //   var el = this.quick_filter_status.rules[i];
      //   cls_qb.addRule(el);
      // }
      
      // if (this.table_setting.pagination.rowsPerPage > 0) {
      //   cls_qb.Offset =
      //     (this.table_setting.pagination.page - 1) *
      //     this.table_setting.pagination.rowsPerPage;
      //   cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      // }

      // cls_qb.Order = [
      //   this.table_setting.pagination.descending
      //     ? "-" + this.table_setting.pagination.sortBy
      //     : this.table_setting.pagination.sortBy
      // ];

      // let result = await common.wBackEndComm.PostData(
      //   "employees/employees_listing/",
      //   cls_qb
      // );

      // if (result.data.Status == 1) {
      //   var start = 1;

      //   for(var i=0,m=result.data.Body.records.length;i<m;i++){
      //     var el = result.data.Body.records[i];

      //     el["rec_id"] = el["id"]
      //     el["id"] = start;
      //     start++;
      //   }

      //   this.table_setting.records = result.data.Body.records;

      //   this.table_setting.pagination.totalItems =
      //     result.data.Body.total_records_after_filtered;
      // } else {
      //   common.wMsgBox.Error(result.data.Description);
      // }
    }
  }
};
</script>

<style scoped>
.tab-style {
  height: 350px;
  margin-top: 5px;
}
</style>
